import HeroBGSrc from "../assets/img/health-support/c4c_1111x600.jpg";
import HeroBGSrcTablet from "../assets/img/health-support/c4c_955x875.jpg";
import HeroBGSrcMobile from "../assets/img/health-support/c4c_580x400.jpg";
import React from "react";

const Check4Cancer = {
  HeroBGSrc: HeroBGSrc,
  HeroBGSrcTablet: HeroBGSrcTablet,
  HeroBGSrcMobile: HeroBGSrcMobile,
  Heading:
    "Has your GP recommended you see a specialist about your raised PSA?",
  Description: (
    <React.Fragment>
      <p>
        We’ve teamed up with Check4Cancer to develop a new prostate cancer
        diagnostic service.
      </p>
      <p>Follow the steps below so that we may be able to help you.</p>
    </React.Fragment>
  ),
  c4cProcessHeader: "How does this work?",
  discussWithYourGPDetail: (
    <React.Fragment>
      <h3>Discuss with your GP</h3>
      <p>
        If you are concerned about prostate-related issues, initially you should
        discuss this with your GP. They may recommend a prostate-specific
        antigen (PSA) blood test. If the result of this is found to be raised,
        your GP may decide that you need to see a specialist for further
        investigation. Alternatively, you may have discussed a raised PSA result
        found at a health check/screening with your GP.
      </p>
    </React.Fragment>
  ),
  callUsDetail: (
    <React.Fragment>
      <h3>Call Us</h3>
      <p>
        Our Personal Advisers will ask some questions to make sure this journey
        is right for you. If eligible, you’ll then be referred on to
        Check4Cancer for an initial clinical assessment.
      </p>
    </React.Fragment>
  ),
  check4CancerDetail: (
    <React.Fragment>
      <h3>Check4Cancer</h3>
      <p>
        The Check4Cancer clinical team will then guide you through the
        appropriate clinical route, booking either a multi-parametric MRI scan
        or a consultation, to help you get a diagnosis and your next steps as
        quickly as possible.
      </p>
    </React.Fragment>
  )
};

export default Check4Cancer;
